var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'cti-is-login': _vm.isLoggedIn, 'cti-not-login': !_vm.isLoggedIn},attrs:{"id":"marquee-main-container"}},_vm._l((_vm.slogans),function(slogan,idx){return _c('div',{key:idx,staticClass:"marquee-item",domProps:{"textContent":_vm._s(slogan)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }